import React, { useContext, useState } from "react";

import { AdditionalOfferInteractionTypeEnum } from "@data-types/analytics-tracker/AdditionalOfferInteractionTypeEnum";
import { LiveEventTypeTrackingEnum } from "@data-types/analytics-tracker/AnalyticsTrackerEnum";
import {
	EventContext,
	LookupContext,
	OfferOptionsContext,
	SportOfferContext,
} from "@gp/components";
import { analyticsTracker } from "@utils/analytics";
import {
	isAdditionalOfferOpenFor,
	useIsAdditionalOfferVisible,
} from "@utils/offer";
import classNames from "classnames";
import { observer } from "mobx-react";

export const AdditionalOfferButtonCore = observer(
	function AdditionalOfferButtonCore(props: {
		additionalOfferCount: number;
		isSecondaryColumnsEmpty?: boolean;
		isEventFeatured?: boolean;
	}) {
		const event = useContext(EventContext);

		const sport = useContext(SportOfferContext);
		const lookupContext = useContext(LookupContext);
		const isAdditionalOfferVisible = useIsAdditionalOfferVisible();

		const homeTeam = lookupContext.teams.get(event.teamOneId || "");
		const awayTeam = lookupContext.teams.get(event.teamTwoId || "");

		// @ts-expect-error
		const { enableInlineAdditionalOffer, additionalOfferToggle } =
			useContext(OfferOptionsContext);

		const [isHover, setIsHover] = useState(false);

		const buttonClasses = classNames(
			"offer__more__btn btn btn--sml btn--ghost btn--icon",
			{
				"offer__more--stretch__btn": !props.isSecondaryColumnsEmpty,
				"is-active":
					enableInlineAdditionalOffer && isAdditionalOfferVisible,
				"is-selected": props.isEventFeatured,
			}
		);

		return (
			<button
				type="button"
				className={buttonClasses}
				onClick={() => {
					if (!isAdditionalOfferOpenFor(event.id)) {
						analyticsTracker.trackAdditionalOfferInteraction(
							event.isLive
								? AdditionalOfferInteractionTypeEnum.LiveAdditionalOffer
								: AdditionalOfferInteractionTypeEnum.PrematchAdditionalOffer,
							sport.abrv,
							homeTeam?.abrv,
							awayTeam?.abrv
						);
					}
					if (event.isLive && !isAdditionalOfferVisible) {
						analyticsTracker.trackLiveEventInteraction(
							LiveEventTypeTrackingEnum.LiveAdditionalOfferOpened
						);
					}
					additionalOfferToggle && additionalOfferToggle(event);
				}}
				onMouseEnter={() => setIsHover(true)}
				onMouseLeave={() => setIsHover(false)}
			>
				<span className="offer__more__count">
					{props.additionalOfferCount > 0 &&
						"+" + props.additionalOfferCount}
				</span>

				<i
					className={classNames(
						"offer__more__icon u-icon u-icon--xtny u-icon--caret-right",
						{
							// "u-icon--caret--right": (!enableInlineAdditionalOffer && !isAdditionalOfferVisible) && !isEventFeatured,
							"u-color--core--snow":
								enableInlineAdditionalOffer &&
								isAdditionalOfferVisible,
							"u-color--sent--danger":
								props.isEventFeatured || isHover,
							"is-hovered": isHover,
						}
					)}
				/>
			</button>
		);
	}
);
